(ns quuppa.qsm.site.subs
  (:require [re-frame.core :as rf]
            [potpuri.core :as p]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.events :as e]
            [clojure.string :as str]
            [quuppa.qsm.site.events :as se]))

;; Below subs rely on sites-query, which has project-id as parameter
(rf/reg-sub ::project-sites
  (fn [[_ project-id]]
    (q/subscribe se/project-sites-query {:project-id project-id} [:result]))
  (fn [sites]
    (sort-by (comp str/lower-case #(or % "") :name) sites)))

(rf/reg-sub ::site-id->site
  (fn [[_ project-id _site-id]]
    (when project-id
      (q/subscribe se/project-sites-query {:project-id (uuid project-id)} [:result])))
  (fn [sites _]
    (p/index-by (comp str :id) (or sites []))))

(rf/reg-sub
  ::site-names-for-project
  (fn [[_ project-id]]
    (q/subscribe se/project-sites-query {:project-id project-id} [:result]))
  (fn [sites _]
    (set (mapv :name sites))))

(rf/reg-sub
  ::site-name->id
  (fn [[_ project-id]]
    (q/subscribe se/project-sites-query {:project-id project-id} [:result]))
  (fn [sites [_ _project-id]]
    (into {} (map (juxt :name :id) sites))))

(rf/reg-sub
  ::duplicate-site-name
  (fn [[_ project-id _site-id]]
    (rf/subscribe [::site-name->id project-id]))
  (fn [site-name->id [_ _project-id site-id site-name]]
    (let [named-site-id (get site-name->id site-name)]
      (and named-site-id
           (not= named-site-id site-id)))))

(rf/reg-sub ::site
  (fn [[_ project-id site-id]]
    (rf/subscribe [::site-id->site project-id site-id]))
  (fn [sites-map [_ _project-id site-id]]
    (get sites-map site-id)))

(rf/reg-sub ::engines
  (q/<-signal-fn e/authorized-qpes-in-project {} [:result])
  (fn [qpes [_ site-id]]
    (filter #(= (:site-id %) site-id) (vals qpes))))

;; FIXME: According to 'Project-centric QSM' sc-19504 there can be multiple QPEs in site, but...
(rf/reg-sub ::site-qpe
  (fn [[_ site-id]]
    (rf/subscribe [::engines site-id]))
  (fn [qpes _]
    ;; FIXME: ... for the time-being, only 1:1 relationship between site<->qpe is assumed
    ;; for easier transition from legacy to new UI.
    ;; Supporting N QPEs per site is TODO and unspecified.
    (first qpes)))

;;
;; New and edit site form
;;

(rf/reg-sub ::site-form
  (fn [db]
    (:site-form db)))

(rf/reg-sub ::qpe-group-form
  (fn [db]
    (:qpe-group-form db)))

(rf/reg-sub ::edit-qpe-group-form
  (fn [db]
    (:edit-qpe-group-form db)))

(rf/reg-sub ::qpe-groups
            (fn [db [_ siteplan-id]]
              (filter #(= (:siteplan-id %) siteplan-id) (:qpe-groups db))))

(rf/reg-sub ::selected-engine-tab
  (fn [db]
    (-> db :ui-state :selected-engine-tab)))
